import React from 'react';
import divider from '../../assets/divider-img.png';
import s1 from '../../assets/tech-stack/1.png';
import s2 from '../../assets/tech-stack/2.png';
import s3 from '../../assets/tech-stack/3.png';
import s4 from '../../assets/tech-stack/4.png';
import s5 from '../../assets/tech-stack/5.png';
import s6 from '../../assets/tech-stack/6.png';
import s7 from '../../assets/tech-stack/7.png';
import s8 from '../../assets/tech-stack/8.png';
import s9 from '../../assets/tech-stack/9.png';
import s10 from '../../assets/tech-stack/10.png';
import s11 from '../../assets/tech-stack/11.png';
import s12 from '../../assets/tech-stack/12.png';
import s13 from '../../assets/tech-stack/13.png';
import s14 from '../../assets/tech-stack/14.png';
import s15 from '../../assets/tech-stack/15.png';

const TechnologyStack = () => {
  return (
    <div>
      <div className="container">
        <div className="center-heading-description">
          <h2>Technology Stack</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            We leverage the latest technologies in the financial tech domain to
            provide our clients with robust, scalable, and efficient solutions.
            Our technology stack is continuously updated to ensure that we stay
            ahead of the curve.
          </p>
        </div>
        <div className="tech-stack-wrapper">
          <div className="tech-item-group m-b">
            <div className="tech-item m-r">
              <img src={s1} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s2} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s3} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s4} alt="technology stack" />
            </div>
            <div className="tech-item">
              <img src={s5} alt="technology stack" />
            </div>
          </div>
          <div className="tech-item-group m-b">
            <div className="tech-item m-r">
              <img src={s6} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s7} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s8} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s9} alt="technology stack" />
            </div>
            <div className="tech-item">
              <img src={s10} alt="technology stack" />
            </div>
          </div>
          <div className="tech-item-group m-b">
            <div className="tech-item m-r">
              <img src={s11} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s12} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s13} alt="technology stack" />
            </div>
            <div className="tech-item m-r">
              <img src={s14} alt="technology stack" />
            </div>
            <div className="tech-item">
              <img src={s15} alt="technology stack" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologyStack;
